import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText } from 'features/Theme';

const styles = {
  hr: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)}
    text-align: center;
    position: relative;
    outline: 0;
    border: 0;
    &:before {
      content: '';
      background-color: ${theme.mui.palette.divider};
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
    }
    &:after {
      content: attr(data-content);
      position: relative;
      display: inline-block;
      padding-left: ${theme.mui.spacing(1)}px;
      padding-right: ${theme.mui.spacing(1)}px;
      line-height: 1.5em;
      background-color: #fff;
    }
  `,
};

export default styles;
